import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from '@shared/error';
import { isEndToEndCheckinError } from '../utils/checkinErrorUtils';
import { setError as setErrorAction } from '@entities/error';
const errorStrategies = [{ validate: isEndToEndCheckinError, messageKey: 'Error.EndToEndCheckin' }];
/**
 * Хук для обработки ошибок при регистрации на рейс
 * По дефолту withDefaultError = false,
 * т.е. выводим модалку только для известных ошибок, указанных в errorStrategies
 */
export const useCheckinError = ({ withDefaultError = false } = {}) => {
    const { t } = useTranslation('Checkin');
    const dispatch = useDispatch();
    const setError = useCallback((error) => {
        dispatch(setErrorAction(error));
    }, [dispatch]);
    const handleError = useCallback((error) => {
        const matchedError = errorStrategies.find(strategy => strategy.validate(error));
        if (matchedError) {
            setError({
                message: t(matchedError.messageKey)
            });
            return true;
        }
        if (withDefaultError) {
            setError({
                message: t('Error.Unknown'),
                details: [{ label: '', value: getErrorMessage(error) }]
            });
        }
        return false;
    }, [dispatch, t, withDefaultError]);
    return {
        /**
         * Базовый сеттер для кастомных или непредвиденных ошибок
         *
         * @param error - ошибка NormalizedError.
         */
        setError,
        /**
         * Централизованный обработчик ошибок
         *
         * @param error - ошибка неизвестного типа.
         * @param withDefaultError - Флаг, определяющий, нужно ли устанавливать дефолтную ошибку
         * @returns true, если найдена известная ошибка, false в противном случае
         */
        handleError
    };
};
